import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debug from 'debug';
import { translate as t } from 'common/utils';
import { getCookieValueByKey } from 'common/utils/cookies';
import Button from 'client/components/common/Button';
import * as css from './GDPR.scss';

const log = debug('app:gdpr');

const docLink =
	'https://img.zeoz.co.il/tos/%D7%AA%D7%A0%D7%90%D7%99+%D7%A9%D7%99%D7%9E%D7%95%D7%A9+%D7%95%D7%9E%D7%93%D7%99%D7%A0%D7%99%D7%95%D7%AA+%D7%A4%D7%A8%D7%98%D7%99%D7%95%D7%AA+%D7%91%D7%90%D7%AA%D7%A8+6+5+18.pdf'; // eslint-disable-line

const localData = {
	name: 'gdpr',
	stringifiedData: JSON.stringify(true),
	set(state) {
		try {
			localStorage.setItem(`${this.name}v2`, state ? this.stringifiedData : '');
		} catch (e) {
			document.cookie = state ? `${this.name}=${this.stringifiedData}` : `${this.name}=`;
		}
	},
	get() {
		return JSON.parse(
			localStorage.getItem(`${this.name}v2`) || getCookieValueByKey(this.name, document.cookie) || null
		);
	},
};

export default class GDPR extends React.Component {
	static propTypes = {
		className: PropTypes.string,
		countryCode: PropTypes.string,
		settings: PropTypes.shape({}),
		translations: PropTypes.shape({}),
	};

	static defaultProps = {
		className: '',
		countryCode: null,
		settings: null,
		translations: null,
	};

	constructor(props) {
		super(props);

		this.state = {
			approved: true, // if not IL & clicked
		};
	}

	static getDerivedStateFromProps(props) {
		let approved;
		const isIsrael = props.countryCode === 'IL';

		if (isIsrael) {
			localData.set(false);
			approved = true;
		} else {
			const data = localData.get();
			approved = !!data;
		}

		log('gds -> approved:', approved);

		return {
			approved,
		};
	}

	handleClick = () => {
		localData.set(true);
		this.setState({ approved: true });
	};

	render() {
		const shouldRender = !this.state.approved && this.props.countryCode && t('gdpr_1').trim();

		if (!shouldRender) {
			return null;
		}

		return (
			<div className={classNames('gdpr', css.gdpr, this.props.className)}>
				<div className={css.content}>
					<p>
						<span>{t('gdpr_1')}</span>
						<a href={docLink} target="_blank" rel="noopener noreferrer">
							{t('gdpr_privacy')}
						</a>
						{` ${t('gdpr_and')} `}
						<a href={docLink} target="_blank" rel="noopener noreferrer">
							{t('gdpr_cookie')}
						</a>
					</p>
					<Button color="black" className={css.okBtn} onClick={this.handleClick} type="button">
						{t('gdpr_btn')}
					</Button>
				</div>
			</div>
		);
	}
}
